
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import IFramePlayground from 'docz-iframe-playground'
import Blockquote from './blockquote'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "blockquote"
    }}>{`Blockquote`}</h1>
    <hr />
    <h2 {...{
      "id": "blockquote-1"
    }}>{`Blockquote`}</h2>
    <Playground __position={1} __code={'<Blockquote\n  text={`Give, give, they cry–and take!\nFor wilful men are they\nWho tax’d our cake, and took our cake,\nTo throw our cake away.`}\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      IFramePlayground,
      Blockquote
    }} mdxType="Playground">
  <Blockquote text={`Give, give, they cry–and take!
  For wilful men are they
  Who tax’d our cake, and took our cake,
  To throw our cake away.`} mdxType="Blockquote" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Blockquote} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;